import { SplitText } from "../vendor/SplitText.min";
import { scroll } from "./scroll";
import { formatTime } from "./helpers"
export const general = {
  init: function () {

    
//console.log('░█████╗░██████╗░░█████╗░██╗░░██╗██╗██████╗░███████╗██╗░░░░░\n██╔══██╗██╔══██╗██╔══██╗██║░░██║██║██╔══██╗██╔════╝██║░░░░░\n███████║██████╔╝██║░░╚═╝███████║██║██████╔╝█████╗░░██║░░░░░\n██╔══██║██╔══██╗██║░░██╗██╔══██║██║██╔═══╝░██╔══╝░░██║░░░░░\n██║░░██║██║░░██║╚█████╔╝██║░░██║██║██║░░░░░███████╗███████╗\n╚═╝░░╚═╝╚═╝░░╚═╝░╚════╝░╚═╝░░╚═╝╚═╝╚═╝░░░░░╚══════╝╚══════╝');

    const urlQuery = new URLSearchParams(window.location.search);

    //Dynamic modes
    $('body').addClass(urlQuery.get("mode"));
    // console.log(
    //   `%cdebugcss: ${urlQuery.get("mode") == 'debugcss' ? '%cON' : '%cOFF'}`, 
    //   `font-size: 20px; font-weight: bold`,
    //   `color: ${urlQuery.get("mode") == 'debugcss' ? 'green' : 'red'}; font-size: 20px`,
    // );

    // Hide Vimeo button
    setTimeout(function(){
      $('.bg-video').find('iframe').find('.vp-player-ui-overlays').hide();
    }, 1000)

    //Widget
    $( "a[class^='widget-btn-']" ).hover(
      function() {
        $( "a[class^='widget-btn-']" ).removeClass('opened');
        $(this).addClass('opened');
      }, function() {
        $( "a[class^='widget-btn-']" ).removeClass('opened');
        $('.widget-btn-book').addClass('opened');
      }
    );

    //Block Temoignages
    general.calculateTemoignage();
    $('.view-temoignage').on('click', function(e){
      e.preventDefault();
      const target = $(this).attr('data-target');
      $('.view-temoignage').removeClass('active');
      $(`.bk-temoignages--item`).addClass('hidding');
      $(this).addClass('active');
      setTimeout(function(){
        $('.bk-temoignages--item').removeClass('active');
        $('.bk-temoignages--item').removeClass('hidding');
        $(`#${target}`).addClass('active');
      }, 250)
    })
    $(window).on("resize", function () {
      general.calculateTemoignage();
    });

    //Arc cream animation
    gsap.set(".arc-cream", { "--bg-pos": "0" });
    var arcReval = gsap
      .timeline({ defaults: { ease: "power1.inOut" } })
      .to(".arc-cream", { "--bg-pos": "-22vw", "--bg-arc-pos": "-24vw" })

    ScrollTrigger.create({
      trigger: ".arc-cream",
      id: "Arc Reveal",
      start: "top 150%",
      end: "top 50%",
      animation: arcReval,
      scrub: true,
      //markers: {startColor:"Crimson", endColor:"DarkMagenta", fontSize:"16px", indent: 130}
    });    


    // ScrollTrigger.create({
    //   trigger: ".active-header",
    //   start: "bottom 50",
    //   onEnter: () => $(".header").addClass("active"),
    //   onLeave: () => $(".header").addClass("active"),
    //   onEnterBack: () => $(".header").removeClass("active"),
    //   onLeaveBack: () => $(".header").removeClass("active"),
    //   scrub: true,      
    // });

    // ScrollTrigger.create({
    //   trigger: ".bk-advantages",
    //   start: "bottom 90%",
    //   end: () => `+=${$(window).height()}`,
    //   scrub: true,
    //   markers: true,
    //   pin: true,
    //   pinSpacing: false,
    // });

    $(".product-thumb-video").each(function () {
      var _this = $(this);
      var player = new Vimeo.Player(_this);
      //player.onload = resize(_this);
      // $(window).on("resize", function () {
      //   resize(_this);
      // });
    });

    function resize(vid) {
      gsap.to(".home-video-hero .bg-video", {opacity: 1});
      const ratio = 1.5;
      const w = vid.innerWidth();
      const h = vid.innerHeight();
      const scale = w / h > ratio ? w / (ratio * h) : (h * ratio) / w;
      $(".bg-video").attr("style", "--this-scale: " + scale);
      vid[0].style.transform = "scale(" + scale + ")";
    }

    var heroVideoTt = new SplitText(".hero-video-title", {
      type: "lines",
    });
    const tlHeroVideoTt = gsap.timeline();
    tlHeroVideoTt.from(heroVideoTt.lines, {
      x: 100,
      opacity: 0.01,
      autoAlpha: 0,
      ease: "power3",
      stagger: 0.2,
      duration: 1,
      delay: 0.5,
    });

    if(heroVideoTt.lines.length == 1) {
      $(".hero-title").addClass('no-pad');
    }

    
    const tLeftRightAnimations = gsap.utils.toArray(".t-left-right-animation");
    tLeftRightAnimations.forEach((tLeftRightAnimation) => {
      let SplitClient = new SplitText(tLeftRightAnimation, { type: "lines", linesClass: "split-child" });
      let lines = SplitClient.lines;
      gsap.to(lines, {      
        x: 0,
        ease: "power4.out",
        stagger: 0.2,
        duration: 2.5,
        scrollTrigger: {
          trigger: tLeftRightAnimation,
          start: 'top 80%',
          scrub: true,
        }
      });
    });

    const linesAnimation = gsap.utils.toArray(".lines-animation");
    linesAnimation.forEach((lineAnimation) => {
      let SplitClient = new SplitText(lineAnimation, { type: "lines", linesClass: "split-child" });
      let lines = SplitClient.lines;
      gsap.from(lines, {      
        opacity:0.01,
        y: 20,
        autoAlpha: 0,
        ease: "power2",
        stagger: 0.2,
        scrollTrigger: {
          trigger: lineAnimation,
          start: 'top 80%',
          end: 'top 40%',
          scrub: 1,     
        }
      });
    });

    const tLeftAnimations = gsap.utils.toArray(".t-left-animation");
    tLeftAnimations.forEach((tLeftAnimation) => {
      let SplitClient = new SplitText(tLeftAnimation, { type: "lines", linesClass: "split-child" });
      let lines = SplitClient.lines;
      gsap.from(lines, {      
        opacity:0.01,
        x: 100,
        autoAlpha: 0,
        ease: "power2",
        stagger: 0.2,
        duration: 1.5,
          scrollTrigger: {
            trigger: tLeftAnimation,
            start: 'top 80%',
        }
      });
    });
//blog
    $ ('.main-blog .row-post:odd').addClass('even');

   


    $("body").on("click", ".single-share-facebook", function (e) {
      e.preventDefault();
      var local = $(this).attr("href");
      window.open(
        "http://www.facebook.com/sharer.php?u=" + local,
        "sharer",
        "toolbar=0,status=0,width=550,height=620,top=" +
          ($(window).height() / 2 - 310) +
          ",left=" +
          ($(window).width() / 2 - 275) +
          ",resizable=yes"
      );
    });
    $("body").on("click", ".single-share-twitter", function (e) {
      e.preventDefault();
      var local = $(this).attr("href");
      var twitterTt = $(this).data("title");
      window.open(
        "https://twitter.com/intent/tweet?text=" +
          twitterTt +
          " - &url=" +
          local,
        "twitterwindow",
        "height=310, width=550, top=" +
          ($(window).height() / 2 - 155) +
          ", left=" +
          ($(window).width() / 2 - 275) +
          ", toolbar=0, location=0, menubar=0, directories=0, scrollbars=0"
      );
    });
    $("body").on("click", ".single-share-instagram", function (e) {
      e.preventDefault();
      var local = $(this).attr("href");
      local = encodeURIComponent(local);
      window.open(
        "https://www.linkedin.com/sharing/share-offsite/?url=" + local,
        "linkedinwindow",
        "toolbar=0,status=0,width=550,height=620,top=" +
          ($(window).height() / 2 - 310) +
          ",left=" +
          ($(window).width() / 2 - 275) +
          ",resizable=yes"
      );
    });

    $(".vicpark-time").each(function(){
      if($('body').attr('data-lang') == 'fr_FR') {
        let hms = $(this).html();
        hms = formatTime(hms);
        hms = hms.replace(":", " h ");
        hms = hms.replace("00", "");
        $(this).html(hms);
      }
    });

    //end blog
    //mini circle reveal block
  //   ScrollTrigger.create({
  //     trigger: ".popup-rendez-vous .popup-rendez-vous--form",
  //     id:"popup",
  //     // markers: true,
  //     pin: true,
  //     pinSpacing: false,
  //     start: "top 12%",
  //   });
  //   let trigger = ScrollTrigger.getById("popup");
  //     $(".open-popup").on("click", function (e) {
  //       trigger.enable();
  //     gsap.to(
  //       ".popup-rendez-vous",
  //       {
  //           opacity:1,
  //           zIndex:"999",
  //           visibility:"visible",
  //           }
  //       );
  // });
  // $(".close-rendez-vous").on("click", function () {
  //   gsap.to(
  //     ".popup-rendez-vous",
  //     {
  //         opacity:0,
  //         visibility:"hidden",
  //         }
  //       );
  //       trigger.pause();
  // });

 //End mini circle reveal block

  },
  calculateTemoignage : function() {
    let minHTemoignages = 0;
    $('.bk-temoignages--item').each(function(){
      if($(this).find('.message').outerHeight() > minHTemoignages) {
        minHTemoignages = $(this).find('.message').outerHeight();
      }
    })
    $('.bk-temoignages--items-container').attr('style', `--min-h:${(minHTemoignages + 80)}px`)
  }
  //popup clinic locator block

  //End clinic store locator block


};
